import { OverlayModule } from '@angular/cdk/overlay';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { RouterModule } from '@angular/router';
import { SuraCommonsUiModule } from '@surainvestments/sura-common-ui';
import { BreadcrumbModule } from 'angular-crumbs';
import { ResizableModule } from 'angular-resizable-element';
import * as marked from 'marked';
import { MarkdownModule, MarkedOptions } from 'ngx-markdown';
import { ChatBotAsesorV2Module } from '../../components/chat-bot-asesor-v2/chat-bot-asesor-v2.module';
import { LastUrlPathPipe } from '../../pipes';
import { AssetService } from '../../services/asset/asset.service';
import { ChatBotLogService } from '../../services/chat-bot/chat-bot-log.service';
import { LogService } from '../../services/logs/logs.service';
import { SharedModule } from '../../shared.module';
import { MaterialModule } from '../material.module';
import { BreadcrumbComponent } from './breadcrumb/breadcrumb.component';
import { menuComponents } from './index';
import { NavbarAccountButtonModule } from './navbar-account-button/navbar-account-button.module';
import { NavbarSearchClientPortfolioComponent } from './navbar-search-client-portfolio/navbar-search-client-portfolio.component';

@NgModule({
  declarations: [
    menuComponents,
    BreadcrumbComponent,
    NavbarSearchClientPortfolioComponent,
    LastUrlPathPipe
  ],
  imports: [
    CommonModule,
    MaterialModule,
    OverlayModule,
    SharedModule,
    BreadcrumbModule,
    RouterModule,
    FormsModule,
    ReactiveFormsModule,
    SuraCommonsUiModule,
    ResizableModule,
    MatDialogModule,
    MatButtonModule,
    MarkdownModule.forRoot({
      markedOptions: {
        provide: MarkedOptions,
        useValue: {
          gfm: true,
          breaks: false,
          pedantic: false,
          smartLists: true,
          smartypants: false,
          renderer: new (class extends marked.Renderer {
            link(href: string, title: string, text: string) {
              return `<a href="${href}" title="${title || ''}" target="_blank">${text}</a>`;
            }
          })()
        }
      }
    }),
    ChatBotAsesorV2Module,
    NavbarAccountButtonModule
  ],
  exports: [
    menuComponents,
    BreadcrumbComponent,
  ],
  providers: [
    ChatBotLogService,
    LogService,
    AssetService,
    { provide: MatDialogRef, useValue: {} },
    { provide: MAT_DIALOG_DATA, useValue: [] },
  ],
})
export class LayoutModule { }
